import { createSlice } from "@reduxjs/toolkit";
import { activeGymStorage } from "../../utils/supportMode";

// The active-gym choice lives per TAB in a support session (sessionStorage), so WTF Go
// support switching an owner's gym never changes the admin's own browser state.
const gymStore = {
  get: () => { try { return activeGymStorage()?.getItem("activeGymId") || null; } catch (e) { return null; } },
  set: (v) => { try { activeGymStorage()?.setItem("activeGymId", v); } catch (e) { /* noop */ } },
  clear: () => { try { activeGymStorage()?.removeItem("activeGymId"); } catch (e) { /* noop */ } },
};

const authSlice = createSlice({
  name: "auth",
  initialState: {
    isAuthenticated: false,
    user: null,
  },
  reducers: {
    login: (state, action) => {
      const user = action.payload;

      // Multi-gym owner: agar pehle koi gym select kiya tha (localStorage) aur
      // wo abhi bhi owner ke gyms me hai, to usi ko active rakho. Warna login
      // response ka default gym_id (pehla gym) chalega.
      if (user?.gyms && Array.isArray(user.gyms) && user.gyms.length > 1) {
        const saved = gymStore.get();
        const match = saved && user.gyms.find((g) => g.value === saved);
        if (match) {
          user.gym_id = match.value;
          user.gym_name = match.label;
        }
      }

      state.isAuthenticated = true;
      state.user = user;
    },
    logout: (state) => {
      state.isAuthenticated = false;
      state.user = null;
      gymStore.clear();
    },
    // Gym switcher — multi-gym owner active gym badalta hai. Saare existing
    // `user.gym_id` consumers apne aap naya gym use karenge.
    setActiveGym: (state, action) => {
      const { value, label } = action.payload || {};
      if (state.user && value) {
        state.user.gym_id = value;
        if (label !== undefined) state.user.gym_name = label;
        gymStore.set(value);
      }
    },
    // My Profile renamed the owner (POST /saas/owner/profile saved users.name) — every
    // `user.name` reader (greeting, header) shows it at once, without a re-login.
    setUserName: (state, action) => {
      const name = typeof action.payload === "string" ? action.payload.trim() : "";
      if (state.user && name) state.user.name = name;
    },
  },
});

export const { login, logout, setActiveGym, setUserName } = authSlice.actions;
export default authSlice.reducer;
